<template>
	<div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">
                        
                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">
										<div class="page-body">
											<h4>Recent Applications</h4>

											<div class="table-responsive">
												<div class="" style="">
													<input type="text" class="form-control" v-model="filter" placeholder="Search recent openings...">
												</div>
												<datatable :columns="table_columns" :data="table_rows" :filter-by="filter"></datatable>
												<div class="" style="text-align: center;">
													<datatable-pager v-model="page" type="long" :per-page="per_page"></datatable-pager>
												</div>
											</div>
										</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navbar1 from '../components/Navbar1.vue'
import navbar2 from '../components/Navbar2.vue'

export default{
	name: "RecentApplications",
	data(){
		return{
			page: 1,
            per_page: 25,
            filter: '',
            table_columns: [
            	{label: "Applicant Name", representedAs: row => {
            		return row.firstname + " " + row.lastname
            	}},
            	{label: "Opening", representedAs: row => {
            		return row.joblistings.jobrole.name
            	}},
                {label: "Email", field: 'emailaddress'},
            	{label: "Date Applied", representedAs: row => {
                    return row.created_at.split(" ")[0]
                }},
            	{label: "Action", representedAs: row => {
            		return '<a target="_blank" href="/opening/'+row.joblisting_id+'/application/'+row.id+'" style="color: #fff;" class="btn btn-primary btn-mat btn-sm"><i class="icofont icofont-eye-alt"></i>View</a>&nbsp;&nbsp;<a href="javascript:void(0)"><i class="fa fa-star-o"></i></a>'
            	}, interpolate: true}
            ],
            table_rows: []
		}
	},
	methods:{
		getApplicantsByDuration: function(){

            var recent = {
                what: 'RecentApplications',
                params:{
                    days: this.$route.params.id
                }
            }

            this.$socket.makeGetRequest(recent)
                .then((response)=>{
                    if(response.type == 'RecentApplications'){
                    	console.log(response.data)
                        this.table_rows = response.data
                    }
                })
                .catch((e)=>{
                    console.log(e)
                })
        },

        init: function(){
        	this.getApplicantsByDuration()
        }
	},
	mounted(){
		this.init()
	},
	components:{
        navbar1,
        navbar2
    }
}
</script>